<div class="table-wrapper-smaller">
  <div class="table-container">
    <table>
      <thead>
          <tr>
              <th>
                <input type="checkbox" id="all" [checked]="allChecked" (click)="selectAll($event.target.checked)">
                <label for="all"></label>
              </th>
              <th class="id sortable" (click)="toOrderBy('x=> x.Id', 2)">
                {{'confeccionesDuplicar.table.id' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Id', 2)"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.DenominacionUnica.Des', 3)">
                {{'confeccionesDuplicar.table.denominacion' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.DenominacionUnica.Des', 3)"></i>
                </div>
              </th>
              <th class="string">{{'confeccionesDuplicar.table.etiquetador' | translate}}</th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Des', 5)">
                {{'confeccionesDuplicar.table.confeccion' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Des', 5)"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Alias', 6)">
                {{'confeccionesDuplicar.table.alias' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Alias', 6)"></i>
                </div>
              </th>
              <th class="number sortable" (click)="toOrderBy('x=> x.Kilos', 7)">
                {{'confeccionesDuplicar.table.peso' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Kilos', 7)"></i>
                </div>
              </th>
              <th class="number">{{'confeccionesDuplicar.table.nEnvasesCaja' | translate}}</th>
              <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 9)">
                {{'global.fecha.insercionShort' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.fechaIns', 9)"></i>
                </div>
              </th>
              <th class="date sortable" (click)="toOrderBy('x=> x.fechaUpd', 10)">
                {{'global.fecha.actualizacionShort' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.fechaUpd', 10)"></i>
                </div>
              </th>
          </tr>
      </thead>
      <tbody *ngFor="let confeccionCaja of confeccionesCaja; let i = index; trackBy: trackByConfeccionCajaId">
          <tr>
              <td>
                <input type="checkbox" [id]="'confeccionCaja_'+i" [checked]="selectedItems.includes(confeccionCaja.id)"
                  (click)="selectConfeccion(confeccionCaja, $event.target.checked)">
                <label [for]="'confeccionCaja_'+i"></label>
              </td>
              <td class="id">{{confeccionCaja.id}}</td>
              <td class="string">{{confeccionCaja.desDenominacionUnica != null ? confeccionCaja.desDenominacionUnica : 'Mix'}}</td>
              <td class="string">{{confeccionCaja.desEtiquetador}}</td>
              <td class="string">{{confeccionCaja.des}}</td>
              <td class="string">{{confeccionCaja.alias}}</td>
              <td class="number">{{confeccionCaja.kilos | number : '1.2-2': defaultLanguage}}</td>
              <td class="number">{{confeccionCaja.cajasConfeccion[0].numEnvasesCaja}}</td>
              <td class="date">{{confeccionCaja.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
              <td class="date">{{confeccionCaja.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
          </tr>
      </tbody>
      <tfoot *ngIf="!confeccionesCaja || (confeccionesCaja && confeccionesCaja.length < 1)">
          <tr>
              <td colspan="9">
                  {{'global.noContent' | translate}}
              </td>
          </tr>
      </tfoot>
    </table>
  </div>
</div>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
